import { Inject, Injectable } from '@angular/core';

import { SERVICE_WORKER_ENABLED } from '../service-worker-enabled.injection-token';
import { ServiceWorkerRegistrationHandler } from './service-worker-registration-handlers.injection-token';

/*
 * This service will unregister the active worker if we the `serviceWorkerEnabled` flag is set to `false`.
 * This will make the next visit to the page behave as a regular, network-bound web application with no caching.
 */
@Injectable()
export class UnregisterIfDisabledService implements ServiceWorkerRegistrationHandler {

    constructor (
        @Inject(SERVICE_WORKER_ENABLED) private readonly serviceWorkerEnabled: boolean
    ) {
    }

    public async handleRegistration(registration: ServiceWorkerRegistration): Promise<void> {
        if (!this.serviceWorkerEnabled) {
            await registration.unregister();
        }
    }
}
